export default __webpack_public_path__ + "static/Asphalte-ebc0bb8f6f37054ab07b7792ca398572.png";